<div>
	<lib-card [isInDialog]="isInDialog()" [isForm]="true">
		<ui-text-form-field
			[title]="'Progress type name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="50"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-select-item-field
			class="push-top-md"
			[placeholder]="'Select unit...'"
			[isRequired]="true"
			[title]="'Unit'"
			[valueAsSignal]="form.unit"
			[items]="unitSelectionItems"
			[isInDialog]="isInDialog()"
		></ui-select-item-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Description'"
			[valueAsSignal]="form.description"
			[isInDialog]="isInDialog()"
			[maxLength]="2000"
		></ui-text-area-form-field>

		<ui-form-save-button
			[isInDialog]="isInDialog()"
			[title]="isEditForm() ? 'Save' : 'Create'"
			[saveHandler]="saveHandler()"
			[logHandler]="formLogHandler()"
		></ui-form-save-button>
	</lib-card>
</div>
